import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Programs } from "@/components/sections/Programs";
import { Staff } from "@/components/sections/Staff";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { useSEO } from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "CT BLAZERS | AAU Basketball in Norwalk, CT — Boys & Girls 10U–17U",
    description:
      "CT BLAZERS is a competitive AAU basketball program in Norwalk, CT for boys and girls ages 10U–17U. AAU teams, summer clinics, private training and winter 3v3. Build. Compete. Develop.",
    keywords:
      "CT Blazers, CT Blazers Basketball, AAU Basketball Connecticut, AAU Basketball Norwalk CT, Youth Basketball Norwalk CT, Basketball Training Norwalk CT, Boys AAU Basketball Connecticut, Girls AAU Basketball Connecticut",
    path: "/",
  });

  return (
    <div className="bg-ink-900">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Programs />
        <Staff />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
